import React from "react";
import "../styles/cancel.css";

const CancellationPolicy = () => {
  return (
    <div className="cancellation-page">
      <div className="cancellation-container">
        <div className="cancellation-content">
          <header className="contact-header">
            <section
              className="hero-section"
              style={{
                backgroundImage: ` url('https://pixeltools.in/img/carousel-1.jpg')`,
                height: "300px",
              }}
            >
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1 className="refund-main-title">Cancellation Policy</h1>{" "}
                </div>
              </div>
            </section>
          </header>
         
          <div className="section-title">
            <h5>Cancellations</h5>
          </div>

          <div className="content-box">
            <p>
              Once your order is placed, it will be dispatched within 7 days
              through delivery.com. Delivery times vary depending on your
              location, typically taking between 3 to 7 working days. A
              confirmed delivery date will be sent to you in the order   
              confirmation email.
            </p>
          </div>

          <div className="section-title">
            <h5>Criteria for Cancellation</h5>
          </div>

          <div className="content-box">
            <p>
              Your order may be cancelled under any of the following
              circumstances:
            </p>

            <ul>
              <li>
                Incorrect or incomplete order address details (house number,
                landmark, etc.)
              </li>
              <li>Incorrect product specification on pixeltools.com</li>
              <li>
                If the area falls under "non-deliverable zone" or "outside
                delivery area" as specified by our logistics courier partner
              </li>
              <li>In case of suspected fraudulent information</li>
            </ul>
          </div>

         
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
